import { useState, useEffect } from "react";
import { useApi } from "../containers/ApiContainer";
import { Aircraft } from "../types";

export const useAircraft = () => {
  const { postgrest } = useApi();
  const [loading, setLoading] = useState(true);
  const [aircraft, setAircraft] = useState<Aircraft[]>([]);
  const [completionStatus, setCompletionStatus] = useState<Record<string, boolean>>({});
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchAircraft();
  }, []);

  const fetchAircraft = async () => {
    try {
      setLoading(true);
      
      // Set schema to web
      postgrest.schema = "web";
      
      // For admin panel, let's try direct table access instead of RPC
      // The aircraft_raw RPC has inverted logic that returns empty for admins
      const { data: aircraftData, error: aircraftError } = await postgrest
        .from("aircraft")
        .select("*")
        .order("make")
        .order("model");

      if (aircraftError) {
        console.error("Aircraft fetch error:", aircraftError);
        throw aircraftError;
      }

      console.log("Aircraft data loaded:", aircraftData?.length || 0, "records");
      const aircraftList = (aircraftData || []) as Aircraft[];
      setAircraft(aircraftList);

      // Only fetch completion status if we have aircraft
      if (aircraftList.length > 0) {
        // Fetch completion status for all aircraft
        const { data: completionData, error: completionError } = await postgrest
          .rpc("is_aircraft_complete", {
            aircraft_ids: aircraftList.map(a => a.id),
          })
          .select();

        if (completionError) {
          throw completionError;
        }

        // Create a map of aircraft ID to completion status
        const statusMap: Record<string, boolean> = {};
        for (const item of completionData || []) {
          statusMap[item.aircraft_id] = item.is_complete;
        }
        setCompletionStatus(statusMap);
      }
    } catch (err: any) {
      setError(err.message || "Failed to fetch aircraft");
      console.error("Error fetching aircraft:", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    aircraft,
    completionStatus,
    error,
    refetch: fetchAircraft,
  };
};